import React from "react";
// import Lottie from "lottie-react";

export function Tile({ label, value, className = "" }) {
  const empty =
    value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "");

  return (
    <div className={"kycViewTile " + className}>
      <div className="kycViewLabel">{label}</div>
      <div className={"kycViewValue " + (empty ? "kycViewMuted" : "")}>
        {empty ? "—" : value}
      </div>
    </div>
  );
}

export function Block({ label, value }) {
  const empty =
    value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "");

  return (
    <div className="kycViewBlock">
      <div className="kycViewLabel">{label}</div>
      <div className={"kycViewValue " + (empty ? "kycViewMuted" : "")}>
        {empty ? "—" : value}
      </div>
    </div>
  );
}

export function Pills({ label, items }) {
  const list = Array.isArray(items) ? items.filter(Boolean) : [];
  return (
    <div className="kycViewTile">
      <div className="kycViewLabel">{label}</div>
      {list.length ? (
        <div className="kycViewPills">
          {list.map((x, i) => (
            <span key={i} className="kycViewPill">
              {x}
            </span>
          ))}
        </div>
      ) : (
        <div className="kycViewValue kycViewMuted">—</div>
      )}
    </div>
  );
}

export function Badge({ text, tone = "neutral" }) {
  const cls =
    tone === "ok"
      ? "kycViewPill kycViewBadgeOk"
      : tone === "warn"
      ? "kycViewPill kycViewBadgeWarn"
      : tone === "bad"
      ? "kycViewPill kycViewBadgeBad"
      : "kycViewPill";
  return <span className={cls}>{text}</span>;
}

// export function InfoItem({ icon, label, children, iconClassName = "" }) {
//   return (
//     <div className="kycInfoItem">
//       <div className={"kycInfoIcon " + iconClassName}>
//         <Lottie animationData={icon} loop autoplay />
//       </div>

//       <div className="kycInfoContent">
//         <div className="kycInfoViewLabel">{label}</div>
//         <div className="kycInfoViewText">{children || "—"}</div>
//       </div>
//     </div>
//   );
// }
